import validate from 'validate.js'
import '../typedefs'

/**
* Validates signup payload
* @param {User} payload Signup payload
*/
export function validateSignup (payload) {
  if (!validate.isObject(payload)) {
    throw new TypeError(`Function "signupUser" expected paylaod of type "object", but got ${typeof payload}`)
  }

  const contraints = {
    firstName: {
      type: 'string',
      presence: true
    },
    lastName: {
      type: 'string',
      presence: true
    },
    email: {
      email: true,
      presence: true
    },
    password: {
      type: 'string',
      presence: true
    },
    confirmPassword: {
      type: 'string',
      presence: true,
      equality: 'password'
    }
  }

  const invalid = validate(payload, contraints)

  if (invalid) {
    throw new Error(JSON.stringify(invalid))
  }

  return true
}

/**
 * Validates user login
 * @param {{ email: String, password: String }} payload Login user payload
 */
export function validateLogin (payload) {
  if (!validate.isObject(payload)) {
    throw new TypeError(`Function "loginUser" expected paylaod of type "object", but got ${typeof payload}`)
  }

  const contraints = {
    email: {
      email: true,
      presence: true
    },
    password: {
      type: 'string',
      presence: true
    }
  }

  const invalid = validate(payload, contraints)

  if (invalid) {
    throw new Error(JSON.stringify(invalid))
  }

  return true
}

/**
 * Validates users's resetPassword paylaod
 * @param {User} payload Reset user password payload
 */
export function validateResetPassword (payload) {
  if (!validate.isObject(payload)) {
    throw new TypeError(`Function "resetPassword" expected paylaod of type "object", but got ${typeof payload}`)
  }

  const contraints = {
    password: {
      type: 'string',
      presence: true
    },
    confirmPassword: {
      type: 'string',
      presence: true,
      equality: 'password'
    },
    token: {
      type: 'string',
      presence: true
    }
  }

  const invalid = validate(payload, contraints)

  if (invalid) {
    throw new Error(JSON.stringify(invalid))
  }

  return true
}

/**
 * Validates inviteUser paylaod
 * @param {{ email: String, role: String }} payload Invite user payload
 */
export function validateInviteUser (payload) {
  if (!validate.isObject(payload)) {
    throw new TypeError(`Function "inviteUser" expected paylaod of type "object", but got ${typeof payload}`)
  }

  const contraints = {
    email: {
      type: 'string',
      presence: true
    },
    role: {
      type: 'string',
      presence: true,
      inclusion: {
        within: ['member', 'pastor', 'admin'],
        message: '"%{value}" is not allowed'
      }
    }
  }

  const invalid = validate(payload, contraints)

  if (invalid) {
    throw new Error(JSON.stringify(invalid))
  }

  return true
}
